import { render, staticRenderFns } from "./CarBusinessTypeEditComponent.vue?vue&type=template&id=634fd5a0"
import script from "./CarBusinessTypeEditComponent.vue?vue&type=script&lang=js"
export * from "./CarBusinessTypeEditComponent.vue?vue&type=script&lang=js"
import style0 from "./CarBusinessTypeEditComponent.vue?vue&type=style&index=0&id=634fd5a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports